document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".section-mega-menu .mega-menu-content-item, .menu-drawer .menu-drawer__main-menu .mobile-mega-menu-content-item");

  menuItems.forEach(menuItem => {
    document.addEventListener("click", function (event) {
    const isClickInside = menuItem.contains(event.target);

    if (isClickInside) {
      menuItem.setAttribute("open", "");
    } else {
      menuItem.removeAttribute("open");
    }
  });
  })  

  const mobileMegaMenuCloses = document.querySelectorAll(".menu-drawer .menu-drawer__main-menu .mobile-mega-menu-content-item .mobile-mega-menu-close");
  mobileMegaMenuCloses.forEach(mobileMegaMenuClose => {
    mobileMegaMenuClose.addEventListener('click', () => {
      const parent = mobileMegaMenuClose.closest('.mobile-mega-menu-content-item');
      setTimeout(() => {parent?.removeAttribute("open");},0)
    })
  })

});